import * as React from 'react';

import { navigateByQuizId } from '~teacher/components/workspaces/WorkspaceQuizzes/utils/navigateByItemType';
import { navigateByFolderId } from '~teacher/components/workspaces/WorkspaceQuizzes/utils/navigateByItemType/navigateByFolderId';
import { TeacherRouter } from '~teacher/context/RouterContext';
import { WorkspaceItem } from '~teacher/hook/workspaces';

import { assertUnreachable } from '../../../../../util/assertUnreachable';

interface UseHandleWorkspaceItemSelectionParams {
  search?: string;
  setSearch?: React.Dispatch<React.SetStateAction<string>>;
  setParentId: React.Dispatch<React.SetStateAction<string>>;
  router: TeacherRouter;
}

export function useHandleWorkspaceItemSelection({
  search,
  setSearch,
  setParentId,
  router,
}: UseHandleWorkspaceItemSelectionParams) {
  return React.useCallback(
    (workspaceItem: WorkspaceItem) => {
      if (search) {
        setSearch?.('');
      }

      switch (workspaceItem.type) {
        case 'folder': {
          const {
            id: workspaceFolderId,
            workspaceId,
            deletedDate,
          } = workspaceItem;

          setParentId(workspaceItem.id);
          navigateByFolderId({
            router: router,
            workspaceId: workspaceId,
            workspaceFolderId: workspaceFolderId,
            isDeleted: !!deletedDate,
          });

          break;
        }
        case 'quiz': {
          const {
            id: workspaceQuizId,
            workspaceId,
            deletedDate,
          } = workspaceItem;
          if (!deletedDate) {
            // To avoid selecting deleted quizzes
            navigateByQuizId({
              router: router,
              workspaceQuizId: workspaceQuizId,
              workspaceId: workspaceId,
            });
          }
          break;
        }
        default: {
          assertUnreachable(workspaceItem);
          break;
        }
      }
    },
    [search, router, setSearch, setParentId]
  );
}
